export const SUPPORTED_DATA_SOURCES = [
  "companies",
  "in_app_dialogs",
  "integrations",
  "email_templates",
  "app_features",
] as const
